import React from "react";
import Navbar from "../Navbar/Navbar";
import Hero from "../Hero/Hero";
import Services from "../Services/Services";
import SoftwareSolutions from "../SoftwareSolutions/SoftwareSolutions";
import OurExpertise from "../OurExpertise/OurExpertise";
// import Portfolio from "../Portfolio/Portfolio";
import Counters from "../Counter/Counters";
import CEOMessage from "../CEOMessage/CEOMessage";
import Testimonials from "../Testimonials/Testimonials";
import About from "../About/About";
import CompanyProfile from "../CompanyProfile/CompanyProfile";
import CaseStudies from "../Case Studies/CaseStudies";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import useReveal from "../../hooks/useReveal"; // custom hook for scroll reveal animations

export default function Home() {
  useReveal(); // auto animate all .reveal on the page

  return (
    <>
      <Navbar />
      <Hero />
      <div className="reveal" data-delay="1">
        <Services />
      </div>
      <div className="reveal" data-delay="8">
        <SoftwareSolutions />
      </div>
      <div className="reveal" data-delay="8">
        <OurExpertise />
      </div>
      {/* <div className="reveal" data-delay="2">
        <Portfolio />
      </div> */}
      <div className="reveal" data-delay="3">
        <About />
      </div>
      <div className="reveal" data-delay="4">
        <CompanyProfile />
      </div>
      <div className="reveal" data-delay="4">
        <Counters />
      </div>
      <div className="reveal" data-delay="8">
        <CEOMessage />
      </div>
      <div className="reveal" data-delay="5">
        <Testimonials />
      </div>
      <div className="reveal" data-delay="6">
        <CaseStudies />
      </div>
      <div className="reveal" data-delay="7">
        <Contact />
      </div>

      {/* Contact (if you have) */}
      <Footer />
    </>
  );
}
